// extracted by mini-css-extract-plugin
export default {"main":"LubricantRecommender_main__Rycze","frame":"LubricantRecommender_frame__JiBaC"};